module.exports = __webpack_public_path__ + "static/img/midcb1.86ccb0ea.png";